/* ==========================================================================
  Purpose: Header CART link opens Shopify cart drawer instead of navigating /cart
  - Delegated click handler (reliable even if header is re-rendered)
  - Updates drawer sections before opening
  - Fallback: if no drawer -> normal navigation to /cart
========================================================================== */

(function () {
  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function getSectionsUrl() {
    var params = new URLSearchParams();
    params.set("sections", "cart-drawer,cart-icon-bubble");
    // Current language root ("/" or "/nl/" ...), so the drawer renders in that language
    var root = (window.routes && window.routes.root_url) || "/";
    if (root.slice(-1) !== "/") root += "/";
    return root + "?" + params.toString();
  }

  async function getCartJson() {
    try {
      var res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function updateDrawerSections(cartDrawer) {
    var res = await fetch(getSectionsUrl(), {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("Sections fetch failed");
    var sections = await res.json();

    if (typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents({
        sections: {
          "cart-drawer": sections["cart-drawer"],
          "cart-icon-bubble": sections["cart-icon-bubble"],
        },
      });
    }
  }

  async function onCartClick(e) {
    var link = e.target.closest("#inkblox-cart-link");
    if (!link) return;

    var cartDrawer = getCartDrawer();
    if (!cartDrawer) {
      // No drawer -> keep default behavior
      return;
    }

    // Drawer exists -> prevent navigation
    e.preventDefault();

    // Remember active element for accessibility if theme supports it
    if (typeof cartDrawer.setActiveElement === "function") {
      cartDrawer.setActiveElement(link);
    }

    try {
      // Unstick "is-empty" based on real cart state
      var cart = await getCartJson();
      if (cart && cart.item_count > 0 && cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }
      if (cart && cart.item_count === 0 && !cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.add("is-empty");
      }

      // Update sections and open
      await updateDrawerSections(cartDrawer);

      if (typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }
    } catch (err) {
      // If anything fails -> fallback to /cart
      window.location.href = link.getAttribute("href") || "/cart";
    }
  }

  document.addEventListener("click", onCartClick, true); // capture = true (more reliable)
})();
